// Module
var code = "<div class=row> <div class=col-md-66> <div class=panel> <div class=panel-content> <h1 class=postTitle></h1> <div class=postDescription></div> <div class=postContent></div> </div> </div> <div class=commentsContainer></div> </div> <div class=\"col-md-33 sidebarContainer\"></div> </div> ";
// Exports
module.exports = code;